/**
 * Car finder wizard — multi-step → Shopify collection filter URL
 *
 * Pravidla (vzájemné vyloučení):
 * - elektro → jen automat (slide převodovky se přeskočí)
 * - elektro + nemám nabíječku → přepneme na hybrid (elektro bez nabíjení nedává smysl)
 * - hatchback → ne 7 míst
 * - 7 míst → silueta velké SUV (+ filtr SUV / 7 míst)
 */
(function () {
  const root = document.querySelector('[data-car-finder]');
  if (!root) return;

  function readJson(id) {
    const el = document.getElementById(id);
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch {
      return {};
    }
  }

  const config = readJson('car-finder-config');
  const fuelGidMap = readJson('car-finder-fuel-gid');
  delete fuelGidMap._dummy;

  const LABEL = {
    purpose: {
      long_trips: 'Dlouhé cesty',
      city: 'Po městě',
      family: 'Rodinné auto',
      business: 'Pro manažery',
      adventure: 'Výlety / příroda',
    },
    body: {
      hatch: 'Hatchback',
      sedan: 'Sedan',
      kombi: 'Kombi',
      suv: 'SUV',
      any: 'Jakákoliv karoserie',
    },
    fuel: {
      electric: 'Elektromotor',
      hybrid: 'Hybrid',
      combustion: 'Nafta / benzín',
      any: 'Bez preference',
    },
    charger: { yes: 'S nabíječkou', no: 'Bez nabíječky → hybrid' },
    transmission: {
      automatic: 'Automat',
      manual: 'Manuál',
      any: 'Bez preference',
    },
    drive: { awd: '4×4', fwd: 'Bez 4×4', any: 'Bez preference' },
    tow: { yes: 'S tažným', no: 'Bez tažného', any: 'Bez preference' },
    seats: { five: 'Do 5 míst', seven: '7 míst', any: 'Bez preference' },
    mileage: { low: 'Do 15 000 km', mid: '15–25 000 km', high: '25 000 km+' },
    term: {
      24: '24 měsíců',
      36: '36 měsíců',
      48: '48 měsíců',
      any: 'Bez preference',
    },
  };

  const BODY_FILTER = {
    hatch: ['Hatchback / Fastback'],
    sedan: ['Sedan / Liftback'],
    kombi: ['Kombi'],
    suv: ['SUV'],
  };

  const PURPOSE_BODY_HINT = {
    long_trips: 'sedan',
    city: 'hatch',
    family: 'kombi',
    business: 'sedan',
    adventure: 'suv',
  };

  const answers = {
    purpose: null,
    body: null,
    fuel: null,
    charger: null,
    transmission: null,
    drive: null,
    tow: null,
    seats: null,
    mileage: null,
    term: null,
  };

  /** @type {string[]} */
  let flow = [];
  let flowIndex = 0;
  let noticeText = '';

  const slides = root.querySelectorAll('[data-slide]');
  const progressEl = root.querySelector('[data-car-finder-progress]');
  const stepLabel = root.querySelector('[data-car-finder-step-label]');
  const backBtn = root.querySelector('[data-car-finder-back]');
  const continueBtn = root.querySelector('[data-car-finder-continue]');
  const nav = root.querySelector('.car-finder__nav');
  const fallbackLink = root.querySelector('[data-car-finder-fallback]');
  const summaryEl = root.querySelector('[data-car-finder-summary]');
  const silhouette = root.querySelector('[data-car-finder-silhouette]');
  const noticeEl = root.querySelector('[data-car-finder-notice]');
  const optionsScrollEls = root.querySelectorAll('[data-car-finder-options-scroll]');
  let optionsScrollTicking = false;
  // musí sedět s délkou fade přechodu v section-car-finder-wizard.css
  const REDIRECT_FADE_MS = 450;
  let redirectFadeTimer = null;
  /** @type {number[]} */
  let redirectUiTimers = [];
  let redirectNavTimer = null;

  function pushDataLayer(eventName, detail) {
    if (typeof window.drivetoAnalyticsPush !== 'function') return;
    window.drivetoAnalyticsPush({
      event: eventName,
      car_finder: detail,
    });
  }

  /** Skutečný pohon po aplikaci pravidel (elektro bez nabíječky = hybrid). */
  function effectiveFuel() {
    if (answers.fuel === 'electric' && answers.charger === 'no') return 'hybrid';
    return answers.fuel;
  }

  function isElectricPath() {
    return effectiveFuel() === 'electric';
  }

  function bodyAllowsSeven(body) {
    return body === 'kombi' || body === 'suv' || !body;
  }

  function applyConstraints(changedKey) {
    noticeText = '';

    // Elektro bez nabíječky → hybrid
    if (answers.fuel === 'electric' && answers.charger === 'no') {
      noticeText = 'Bez nabíječky elektro nedává smysl — pokračujeme s hybridem.';
    }

    // Elektro = jen automat (krok převodovky se přeskočí, bez hlášky)
    if (isElectricPath()) {
      if (answers.transmission === 'manual' || answers.transmission === 'any') {
        answers.transmission = 'automatic';
      }
      if (!answers.transmission) answers.transmission = 'automatic';
    }

    // 7 míst na malé karoserii → přesun na SUV
    if (answers.seats === 'seven' && answers.body && !bodyAllowsSeven(answers.body)) {
      answers.body = 'suv';
      noticeText = '7 míst dává smysl u většího auta — nastavili jsme SUV.';
    }

    // Hatchback → zrušit 7 míst
    if (answers.body && !bodyAllowsSeven(answers.body) && answers.seats === 'seven') {
      answers.seats = 'five';
    }
  }

  function rebuildFlow() {
    flow = ['purpose', 'body', 'fuel'];

    if (answers.fuel === 'electric') {
      flow.push('charger');
    }

    // Převodovka jen když to není čisté elektro (tam je vždy automat)
    if (!isElectricPath()) {
      flow.push('transmission');
    }

    flow.push('drive', 'tow');

    // U hatchbacku přeskočíme místa (max 5, není co řešit), u ostatních se zeptáme
    if (!answers.body || bodyAllowsSeven(answers.body)) {
      flow.push('seats');
    } else if (!answers.seats) {
      answers.seats = 'five';
    }

    flow.push('mileage', 'term', 'finish');
  }

  function resolveSilhouetteBody() {
    if (answers.seats === 'seven') return 'suv7';
    if (answers.body) return answers.body;
    if (answers.purpose) return PURPOSE_BODY_HINT[answers.purpose] || 'suv';
    return 'suv';
  }

  function setNotice(text) {
    if (!noticeEl) return;
    if (text) {
      noticeEl.hidden = false;
      noticeEl.textContent = text;
    } else {
      noticeEl.hidden = true;
      noticeEl.textContent = '';
    }
  }

  function updateOptionVisibility() {
    // Manuál schovat u elektro
    root.querySelectorAll('[data-answer="transmission"][data-value="manual"]').forEach((btn) => {
      btn.hidden = isElectricPath();
      btn.disabled = isElectricPath();
    });

    // 7 míst schovat u malých karoserií
    const allowSeven = bodyAllowsSeven(answers.body);
    root.querySelectorAll('[data-answer="seats"][data-value="seven"]').forEach((btn) => {
      btn.hidden = !allowSeven;
      btn.disabled = !allowSeven;
    });
  }

  function silhouetteSrcFor(body) {
    const withTow = answers.tow === 'yes';
    if (withTow) {
      return (
        silhouette.getAttribute(`data-src-${body}-tow`) ||
        silhouette.getAttribute(`data-src-${body}`) ||
        silhouette.getAttribute('data-src-suv-tow') ||
        silhouette.getAttribute('data-src-suv')
      );
    }
    return silhouette.getAttribute(`data-src-${body}`) || silhouette.getAttribute('data-src-suv');
  }

  const visualPreloads = new Map();
  const BODY_KEYS = ['hatch', 'sedan', 'kombi', 'suv', 'suv7'];
  const VISUAL_MS = 600;
  const VISUAL_EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';
  let visualToken = 0;

  function prefersReducedMotion() {
    return typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function preloadVisual(src) {
    if (!src) return Promise.resolve();
    if (visualPreloads.has(src)) return visualPreloads.get(src);
    const promise = new Promise((resolve) => {
      const preload = new Image();
      preload.decoding = 'async';
      preload.onload = resolve;
      preload.onerror = () => {
        visualPreloads.delete(src);
        resolve();
      };
      preload.src = src;
    });
    visualPreloads.set(src, promise);
    return promise;
  }

  function collectCarSources() {
    if (!silhouette) return [];
    const sources = [];
    BODY_KEYS.forEach((body) => {
      const normal = silhouette.getAttribute(`data-src-${body}`);
      const tow = silhouette.getAttribute(`data-src-${body}-tow`);
      if (normal) sources.push(normal);
      if (tow) sources.push(tow);
    });
    return sources;
  }

  function warmCarBodies() {
    collectCarSources().forEach((src) => {
      void preloadVisual(src);
    });
  }

  function waitFrame() {
    return new Promise((resolve) => window.requestAnimationFrame(resolve));
  }

  function stopAnimations(el) {
    if (!el || typeof el.getAnimations !== 'function') return;
    el.getAnimations().forEach((anim) => {
      try {
        anim.cancel();
      } catch {
        /* ignore */
      }
    });
  }

  function resetCarMedia(carMedia) {
    if (!carMedia) return;
    stopAnimations(carMedia);
    const img = carMedia.querySelector('[data-car-finder-car-img], .car-finder-silhouette__img');
    if (img) stopAnimations(img);
    carMedia.style.removeProperty('opacity');
    carMedia.style.removeProperty('visibility');
    carMedia.style.removeProperty('filter');
    carMedia.style.removeProperty('transform');
    if (img) {
      img.style.removeProperty('opacity');
      img.style.removeProperty('visibility');
      img.style.removeProperty('filter');
      img.style.removeProperty('transform');
    }
  }

  function setCarState(carImg, nextBody, nextTow, nextCarSrc) {
    if (nextBody) silhouette.setAttribute('data-body', nextBody);
    silhouette.setAttribute('data-tow', nextTow === 'yes' ? 'yes' : '');
    if (carImg && nextCarSrc) carImg.setAttribute('src', nextCarSrc);
  }

  function clearSwapLayers(stage) {
    if (!stage) return;
    stage.querySelectorAll('[data-car-finder-swap]').forEach((el) => {
      stopAnimations(el);
      el.remove();
    });
  }

  /**
   * Staré auto odjede doleva, nové přijede zprava — jen na live media (bez clone vrstev).
   */
  async function transitionVisuals({ carImg, carMedia, nextBody, nextTow, nextCarSrc }) {
    const token = ++visualToken;
    const nextTowVal = nextTow === 'yes' ? 'yes' : '';
    const fromSrc = (carImg && (carImg.currentSrc || carImg.getAttribute('src'))) || '';
    const fromBody = (silhouette && silhouette.getAttribute('data-body')) || '';
    const fromTow = (silhouette && silhouette.getAttribute('data-tow')) || '';
    const stage =
      (carMedia && carMedia.parentElement) || (silhouette && silhouette.querySelector('.car-finder-silhouette__stage'));

    const carChanged =
      (Boolean(nextBody) && nextBody !== fromBody) ||
      nextTowVal !== fromTow ||
      Boolean(nextCarSrc && !silhouetteUrlEquals(fromSrc, nextCarSrc));

    const applyAll = async () => {
      setCarState(carImg, nextBody, nextTowVal, nextCarSrc);
      if (carImg && typeof carImg.decode === 'function') {
        try {
          await carImg.decode();
        } catch {
          /* ignore */
        }
      }
    };

    const cleanup = async () => {
      clearSwapLayers(stage);
      if (stage) stage.style.removeProperty('overflow');
      resetCarMedia(carMedia);
      await applyAll();
    };

    clearSwapLayers(stage);

    if (!carChanged) {
      await cleanup();
      return;
    }

    await preloadVisual(nextCarSrc);
    if (token !== visualToken) return;

    if (prefersReducedMotion() || !carMedia || !carImg || typeof carMedia.animate !== 'function') {
      await cleanup();
      return;
    }

    const travel = Math.max((stage && stage.clientWidth * 0.7) || 220, 180);
    const exitTo = `translate3d(${-travel}px, 0, 0)`;
    const enterFrom = `translate3d(${travel}px, 0, 0)`;
    const parked = 'translate3d(0, 0, 0)';
    const prevOverflow = stage ? stage.style.overflow : '';
    if (stage) stage.style.overflow = 'hidden';

    try {
      await carMedia.animate(
        [
          { transform: parked, opacity: 1 },
          { transform: exitTo, opacity: 0 },
        ],
        {
          duration: Math.round(VISUAL_MS * 0.48),
          easing: 'cubic-bezier(0.4, 0, 0.7, 0.2)',
          fill: 'forwards',
        },
      ).finished;

      if (token !== visualToken) return;

      await applyAll();
      await waitFrame();
      if (token !== visualToken) return;

      await carMedia.animate(
        [
          { transform: enterFrom, opacity: 0 },
          { transform: parked, opacity: 1 },
        ],
        {
          duration: Math.round(VISUAL_MS * 0.62),
          easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)',
          fill: 'forwards',
        },
      ).finished;
    } catch {
      /* cancelled */
    } finally {
      if (token === visualToken) {
        clearSwapLayers(stage);
        if (stage) {
          if (prevOverflow) stage.style.overflow = prevOverflow;
          else stage.style.removeProperty('overflow');
        }
        resetCarMedia(carMedia);
        await applyAll();
      }
    }
  }

  function updateScene(carImg, nextCarSrc, nextBody) {
    void transitionVisuals({
      carImg,
      carMedia: carImg && carImg.closest('.car-finder-silhouette__media'),
      nextBody,
      nextTow: answers.tow,
      nextCarSrc,
    });
  }

  function silhouetteUrlEquals(a, b) {
    if (!a || !b) return false;
    if (a === b) return true;
    try {
      return new URL(a, window.location.href).pathname === new URL(b, window.location.href).pathname;
    } catch {
      return false;
    }
  }

  function keepSilhouetteInView() {
    // Na mobilu nechceme po každém výběru skákat zpět k obrázku auta.
  }

  function syncOptionsScrollFade(el) {
    if (!el) return;
    const maxScroll = el.scrollHeight - el.clientHeight;
    const canScroll = maxScroll > 1;
    const atTop = el.scrollTop <= 1;
    const atBottom = el.scrollTop >= maxScroll - 1;
    el.classList.toggle('is-scroll-top', canScroll && !atTop);
    el.classList.toggle('is-scroll-bottom', canScroll && !atBottom);
  }

  function syncActiveOptionsScrollFade() {
    const isMobile = typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 989px)').matches;
    if (!isMobile || root.classList.contains('is-finish')) {
      optionsScrollEls.forEach((el) => {
        el.classList.remove('is-scroll-top', 'is-scroll-bottom');
      });
      return;
    }

    const activeSlide = root.querySelector('.car-finder__slide.is-active');
    const activeScroll = activeSlide && activeSlide.querySelector('[data-car-finder-options-scroll]');
    optionsScrollEls.forEach((el) => {
      if (el !== activeScroll) {
        el.classList.remove('is-scroll-top', 'is-scroll-bottom');
        return;
      }
      syncOptionsScrollFade(el);
    });
  }

  function requestOptionsScrollFadeSync() {
    if (optionsScrollTicking) return;
    optionsScrollTicking = true;
    window.requestAnimationFrame(() => {
      optionsScrollTicking = false;
      syncActiveOptionsScrollFade();
    });
  }

  function updateSilhouette() {
    if (!silhouette) return;
    const body = resolveSilhouetteBody();
    const img = silhouette.querySelector('[data-car-finder-car-img]');
    const nextSrc = silhouetteSrcFor(body);

    silhouette.setAttribute('data-fuel', effectiveFuel() || '');
    silhouette.setAttribute('data-drive', answers.drive || '');
    silhouette.setAttribute('data-seats', answers.seats || '');
    silhouette.setAttribute('data-transmission', answers.transmission || '');
    silhouette.classList.toggle('is-building', Boolean(answers.purpose || answers.body));
    silhouette.classList.toggle('is-complete', flow[flowIndex] === 'finish');
    silhouette.classList.toggle('has-tow', answers.tow === 'yes');
    updateScene(img, nextSrc, body);

    const stage = Math.min(flowIndex + 1, Math.max(1, flow.filter((s) => s !== 'finish').length));
    silhouette.setAttribute('data-stage', String(stage));

    const hint = silhouette.querySelector('[data-car-finder-silhouette-hint]');
    if (hint) {
      const bits = [];
      if (body === 'suv7') bits.push('Velké SUV · 7 míst');
      else if (answers.body) bits.push(LABEL.body[answers.body]);
      else if (answers.purpose) bits.push(LABEL.purpose[answers.purpose]);
      const fuel = effectiveFuel();
      if (fuel && fuel !== 'any') bits.push(LABEL.fuel[fuel]);
      if (answers.tow === 'yes') bits.push('tažné');
      if (answers.drive === 'awd') bits.push('4×4');
      hint.textContent = bits.length ? bits.join(' · ') : 'Silueta se skládá podle vašich odpovědí';
    }

    const badges = silhouette.querySelector('[data-car-finder-badges]');
    if (badges) {
      const items = [];
      const fuel = effectiveFuel();
      if (fuel === 'electric') items.push('Elektro');
      if (fuel === 'hybrid') items.push('Hybrid');
      if (fuel === 'combustion') items.push('Nafta / benzín');
      if (answers.transmission === 'automatic') items.push('Automat');
      if (answers.transmission === 'manual') items.push('Manuál');
      if (answers.drive === 'awd') items.push('4×4');
      if (answers.tow === 'yes') items.push('Tažné');
      if (answers.seats === 'seven') items.push('7 míst');
      badges.innerHTML = items.map((t) => `<li class="car-finder-silhouette__badge">${t}</li>`).join('');
    }

    keepSilhouetteInView();
    setNotice(noticeText);
    requestOptionsScrollFadeSync();
  }

  function highlightBodyHints() {
    const hint = PURPOSE_BODY_HINT[answers.purpose];
    root.querySelectorAll('[data-slide="body"] [data-answer="body"]').forEach((btn) => {
      btn.classList.toggle('is-hint', hint && btn.getAttribute('data-value') === hint);
    });
  }

  function currentSlideKey() {
    const activeSlide = root.querySelector('.car-finder__slide.is-active');
    return (activeSlide && activeSlide.getAttribute('data-slide')) || flow[flowIndex] || null;
  }

  function syncSelectedOption(slideName) {
    const slide = root.querySelector(`[data-slide="${slideName}"]`);
    if (!slide) return;
    const value = answers[slideName];
    slide.querySelectorAll('.car-finder__option').forEach((el) => {
      const match = Boolean(value) && el.getAttribute('data-value') === value;
      el.classList.toggle('is-selected', match);
      el.setAttribute('aria-checked', match ? 'true' : 'false');
    });
  }

  function syncContinueButton() {
    if (!continueBtn) return;
    const name = currentSlideKey();
    const onFinish = name === 'finish';
    continueBtn.hidden = onFinish;
    if (onFinish) return;
    const answered = Boolean(name && answers[name]);
    continueBtn.disabled = !answered;
  }

  function advanceToNext() {
    const activeName = currentSlideKey();
    const activeIndex = flow.indexOf(activeName);
    if (activeIndex >= 0) flowIndex = activeIndex;

    applyConstraints(activeName);
    rebuildFlow();

    const currentName = activeName || flow[flowIndex];
    const key = currentName;
    let nextIndex = flowIndex + 1;

    if (key === 'purpose') {
      nextIndex = flow.indexOf('body');
    } else if (key === 'fuel') {
      nextIndex = flow.indexOf('fuel') + 1;
    } else if (key === 'charger') {
      nextIndex = flow.indexOf('charger') + 1;
    } else {
      const idx = flow.indexOf(key);
      nextIndex = idx >= 0 ? idx + 1 : flowIndex + 1;
    }

    while (nextIndex < flow.length - 1 && flow[nextIndex] === currentName) {
      nextIndex += 1;
    }

    goTo(nextIndex);
  }

  function showSlide(name) {
    slides.forEach((slide) => {
      const match = slide.getAttribute('data-slide') === name;
      slide.hidden = !match;
      slide.classList.toggle('is-active', match);
    });

    if (name !== 'finish') {
      const matchPanel = root.querySelector('[data-car-finder-finish-match]');
      const emptyPanel = root.querySelector('[data-car-finder-finish-empty]');
      if (matchPanel) matchPanel.hidden = false;
      if (emptyPanel) emptyPanel.hidden = true;
    }

    const visibleSteps = Math.max(1, flow.filter((s) => s !== 'finish').length);
    const currentStep = name === 'finish' ? visibleSteps : Math.min(Math.max(flowIndex + 1, 1), visibleSteps);
    if (stepLabel) {
      stepLabel.textContent =
        name === 'finish' ? `Hotovo · ${visibleSteps} z ${visibleSteps}` : `Krok ${currentStep} z ${visibleSteps}`;
    }
    if (progressEl) {
      const pct = name === 'finish' ? 100 : Math.round((currentStep / visibleSteps) * 100);
      progressEl.style.setProperty('--car-finder-progress', `${pct}%`);
      progressEl.setAttribute('aria-valuenow', String(pct));
      progressEl.setAttribute('data-progress', String(pct));
    }
    root.classList.toggle('is-finish', name === 'finish');
    if (name !== 'finish') root.classList.remove('is-finish-reveal', 'is-finish-empty');
    if (backBtn) backBtn.hidden = flowIndex === 0;
    if (name === 'body') highlightBodyHints();
    updateOptionVisibility();
    syncSelectedOption(name);
    syncContinueButton();
    updateSilhouette();
    syncFinishMatchActions();
    requestOptionsScrollFadeSync();
  }

  function goTo(index) {
    flowIndex = Math.max(0, Math.min(index, flow.length - 1));
    const name = flow[flowIndex];
    showSlide(name);
    pushDataLayer('car_finder_slide', { slide: name, index: flowIndex, answers: { ...answers } });
    if (name === 'finish') finish();
  }

  function splitHandles(str) {
    return String(str || '')
      .split(',')
      .map((s) => s.trim().toLowerCase())
      .filter(Boolean);
  }

  function resolveFuelGids(fuelKey) {
    if (!fuelKey || fuelKey === 'any') return [];
    const wanted = splitHandles(config.fuelHandles?.[fuelKey] || '');
    const gids = [];
    Object.keys(fuelGidMap).forEach((handle) => {
      const h = handle.toLowerCase();
      if (wanted.some((w) => h === w || h.includes(w) || w.includes(h))) {
        gids.push(fuelGidMap[handle]);
      }
    });
    return [...new Set(gids)];
  }

  function appendCarFinderUtm(url) {
    if (!url) return url;
    try {
      const parsed = new URL(url, window.location.origin);
      parsed.searchParams.set('utm_source', 'driveto');
      parsed.searchParams.set('utm_medium', 'car-finder');
      parsed.searchParams.set('utm_campaign', 'kalkulacka-operativni-leasing');
      return `${parsed.pathname}${parsed.search}${parsed.hash}`;
    } catch {
      return url;
    }
  }

  /**
   * @param {Record<string, string|null>|null} [answerOverrides]
   */
  function resolvedAnswers(answerOverrides) {
    return { ...answers, ...(answerOverrides || {}) };
  }

  /**
   * @param {Record<string, string|null>} a
   */
  function fuelFromAnswers(a) {
    if (a.fuel === 'electric' && a.charger === 'no') return 'hybrid';
    return a.fuel;
  }

  /**
   * @param {Record<string, string|null>|null} [answerOverrides]
   */
  function buildCollectionUrl(answerOverrides) {
    const a = resolvedAnswers(answerOverrides);
    const handle = config.collectionHandle || root.dataset.collectionHandle || 'operativni-leasing';
    const params = [];
    const purpose = config.purposeMap?.[a.purpose] || {};

    let bodyKey = a.body === 'any' ? null : a.body;
    if (a.seats === 'seven' && bodyKey && !bodyAllowsSeven(bodyKey)) {
      bodyKey = 'suv';
    }
    if (a.seats === 'seven' && (!bodyKey || bodyKey === 'kombi')) {
      // 7 míst typicky SUV — přidej SUV filtr, kombi nech pokud bylo zvoleno
      if (bodyKey === 'kombi') {
        BODY_FILTER.kombi.forEach((type) => {
          params.push(`filter.p.m.custom.car_type=${encodeURIComponent(type)}`);
        });
        params.push(`filter.p.m.custom.car_type=${encodeURIComponent('SUV')}`);
      } else {
        (BODY_FILTER.suv || []).forEach((type) => {
          params.push(`filter.p.m.custom.car_type=${encodeURIComponent(type)}`);
        });
      }
    } else {
      const bodyTypes = BODY_FILTER[bodyKey] || purpose.carTypes || [];
      bodyTypes.forEach((type) => {
        params.push(`filter.p.m.custom.car_type=${encodeURIComponent(type)}`);
      });
    }

    let fuelKey = fuelFromAnswers(a);
    if (fuelKey === 'any') fuelKey = purpose.preferFuel || null;

    resolveFuelGids(fuelKey).forEach((gid) => {
      params.push(`filter.p.m.custom.car_fuel=${encodeURIComponent(gid)}`);
    });

    let transmissionKey = a.transmission;
    if (fuelFromAnswers(a) === 'electric') transmissionKey = 'automatic';
    const transmissionGid = config.transmissionGids?.[transmissionKey];
    if (transmissionGid) {
      params.push(`filter.p.m.custom.transmission=${encodeURIComponent(transmissionGid)}`);
    }

    if (a.drive === 'awd') {
      params.push('filter.p.m.custom.drive_type=1');
    }

    const towGid = config.equipmentGids?.tow;
    if (a.tow === 'yes' && towGid) {
      params.push(`filter.p.m.custom.car_equipment_filter=${encodeURIComponent(towGid)}`);
    }

    const seatsGid = config.equipmentGids?.sevenSeats;
    if (a.seats === 'seven' && seatsGid) {
      params.push(`filter.p.m.custom.car_equipment_filter=${encodeURIComponent(seatsGid)}`);
    }

    const mileageValue = config.mileageOptions?.[a.mileage];
    if (mileageValue) {
      params.push(`filter.v.option.roční+nájezd=${encodeURIComponent(mileageValue)}`);
    }

    const termValue = config.termOptions?.[a.term];
    if (termValue) {
      params.push(`filter.v.option.délka+pronájmu=${encodeURIComponent(termValue)}`);
    }

    let url = `/collections/${handle}`;
    if (params.length) url += `?${params.join('&')}`;
    url += '#ProductGridContainer';
    return appendCarFinderUtm(url);
  }

  /**
   * Jedno kritérium = jedna alternativa (nejmenší uvolnění, které něco najde).
   * Pořadí = typické blokující filtry (nájezd první).
   * @returns {{ key: string, from: string, to: string, priority: number }[]}
   */
  function buildRelaxProbes() {
    /** @type {{ key: string, from: string, to: string, priority: number }[]} */
    const probes = [];
    const push = (key, from, to, priority) => {
      if (answers[key] !== from) return;
      probes.push({ key, from, to, priority });
    };

    // roční nájezd — uvolnit nahoru
    push('mileage', 'low', 'mid', 10);
    push('mileage', 'low', 'high', 11);
    push('mileage', 'mid', 'high', 12);

    // délka smlouvy — delší / bez preference
    push('term', '24', '36', 20);
    push('term', '24', '48', 21);
    push('term', '24', 'any', 22);
    push('term', '36', '48', 23);
    push('term', '36', 'any', 24);
    push('term', '48', 'any', 25);

    // 4×4 / tažné / 7 míst
    push('drive', 'awd', 'any', 30);
    push('tow', 'yes', 'any', 40);
    push('seats', 'seven', 'five', 50);

    // karoserie — u elektro hatch + 4×4 často stačí SUV
    push('body', 'hatch', 'suv', 55);
    push('body', 'sedan', 'suv', 55);
    push('body', 'kombi', 'suv', 55);
    push('body', 'hatch', 'sedan', 56);
    push('body', 'sedan', 'hatch', 56);
    push('body', 'kombi', 'hatch', 56);
    push('body', 'hatch', 'any', 58);
    push('body', 'sedan', 'any', 58);
    push('body', 'kombi', 'any', 58);
    push('body', 'suv', 'any', 58);

    // převodovka / pohon
    push('transmission', 'manual', 'any', 60);
    push('transmission', 'automatic', 'any', 61);
    push('fuel', 'electric', 'any', 70);
    push('fuel', 'hybrid', 'any', 71);
    push('fuel', 'combustion', 'any', 72);

    probes.sort((x, y) => x.priority - y.priority);
    return probes;
  }

  function buildCombinedRelaxProbes(probes) {
    const byChange = new Map();
    probes.forEach((probe) => {
      byChange.set(`${probe.key}:${probe.to}`, probe);
    });

    const get = (key, to) => byChange.get(`${key}:${to}`);
    const combos = [];
    const pushCombo = (changes, priority) => {
      if (!changes.every(Boolean)) return;
      combos.push({
        key: changes[0].key,
        from: changes[0].from,
        to: changes[0].to,
        priority,
        changes,
      });
    };

    pushCombo([get('tow', 'any'), get('term', '36')], 110);
    pushCombo([get('tow', 'any'), get('body', 'suv')], 120);
    pushCombo([get('body', 'suv'), get('term', 'any')], 130);
    pushCombo([get('tow', 'any'), get('term', 'any')], 140);
    pushCombo([get('tow', 'any'), get('mileage', 'high')], 150);
    pushCombo([get('body', 'any'), get('term', 'any')], 160);
    pushCombo([get('fuel', 'any'), get('term', 'any')], 170);
    pushCombo([get('tow', 'any'), get('body', 'suv'), get('term', 'any')], 210);
    pushCombo([get('body', 'any'), get('tow', 'any'), get('term', 'any')], 220);
    pushCombo([get('tow', 'any'), get('mileage', 'high'), get('term', 'any')], 230);
    pushCombo([get('tow', 'any'), get('fuel', 'any'), get('term', 'any')], 240);

    combos.sort((x, y) => x.priority - y.priority);
    return combos;
  }

  /**
   * @param {number} count
   */
  function formatCarCount(count) {
    const abs = Math.abs(count);
    const mod10 = abs % 10;
    const mod100 = abs % 100;
    if (abs === 1) return '1 vůz';
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return `${count} vozy`;
    return `${count} vozů`;
  }

  /**
   * @param {{ key: string, from: string, to: string, count: number }} alt
   */
  function formatAlternativeParts(alt) {
    const fromLabel = LABEL[alt.key]?.[alt.from] || alt.from;
    const toLabel = LABEL[alt.key]?.[alt.to] || (alt.to === 'any' ? 'bez preference' : alt.to);
    const countLabel = formatCarCount(alt.count);

    let changePrefix = 'Změnit';
    if (alt.key === 'mileage') changePrefix = 'Roční nájezd';
    else if (alt.key === 'term') changePrefix = 'Délka smlouvy';
    else if (alt.key === 'body') changePrefix = 'Karoserie';
    else if (alt.key === 'drive' && alt.from === 'awd') {
      return {
        changeHtml: '<span class="car-finder__alternative-to">Bez nutnosti 4×4</span>',
        countLabel,
        label: `Když nebudete trvat na 4×4, máme pro vás ${countLabel}`,
      };
    } else if (alt.key === 'tow' && alt.from === 'yes') {
      return {
        changeHtml: '<span class="car-finder__alternative-to">Bez tažného zařízení</span>',
        countLabel,
        label: `Když nebudete potřebovat tažné, máme pro vás ${countLabel}`,
      };
    } else if (alt.key === 'seats' && alt.from === 'seven') {
      return {
        changeHtml:
          '<span class="car-finder__alternative-from">7 míst</span><span class="car-finder__alternative-arrow">→</span><span class="car-finder__alternative-to">Do 5 míst</span>',
        countLabel,
        label: `Když stačí do 5 míst místo 7, máme pro vás ${countLabel}`,
      };
    } else if (alt.key === 'transmission') changePrefix = 'Převodovka';
    else if (alt.key === 'fuel') changePrefix = 'Pohon';

    const changeHtml = `${changePrefix}: <span class="car-finder__alternative-from">${fromLabel}</span><span class="car-finder__alternative-arrow">→</span><span class="car-finder__alternative-to">${toLabel}</span>`;

    let label = `Když změníte ${fromLabel} → ${toLabel}, máme pro vás ${countLabel}`;
    if (alt.key === 'mileage') {
      label = `Když si dáte roční nájezd ${toLabel} místo ${fromLabel}, máme pro vás ${countLabel}`;
    } else if (alt.key === 'term') {
      label =
        alt.to === 'any'
          ? `Když nebudete trvat na délce smlouvy ${fromLabel}, máme pro vás ${countLabel}`
          : `Když zvolíte smlouvu na ${toLabel} místo ${fromLabel}, máme pro vás ${countLabel}`;
    } else if (alt.key === 'transmission') {
      label = `Když nebudete trvat na převodovce (${fromLabel}), máme pro vás ${countLabel}`;
    } else if (alt.key === 'fuel') {
      label = `Když nebudete trvat na pohonu (${fromLabel}), máme pro vás ${countLabel}`;
    } else if (alt.key === 'body') {
      label =
        alt.to === 'any'
          ? `Když nebudete trvat na karoserii (${fromLabel}), máme pro vás ${countLabel}`
          : `Když zvolíte ${toLabel} místo ${fromLabel}, máme pro vás ${countLabel}`;
    }

    return { changeHtml, countLabel, label };
  }

  function formatCombinedAlternativeParts(changes, count) {
    const countLabel = formatCarCount(count);
    const changeHtml = changes
      .map(
        (change) =>
          formatAlternativeParts({
            key: change.key,
            from: change.from,
            to: change.to,
            count,
          }).changeHtml,
      )
      .join('<br>');
    const readableChanges = changes
      .map((change) => {
        const fromLabel = LABEL[change.key]?.[change.from] || change.from;
        const toLabel = LABEL[change.key]?.[change.to] || (change.to === 'any' ? 'bez preference' : change.to);
        return `${fromLabel} → ${toLabel}`;
      })
      .join(', ');

    return {
      changeHtml,
      countLabel,
      label: `Když upravíte ${readableChanges}, máme pro vás ${countLabel}`,
    };
  }

  function changesForProbe(probe) {
    return probe.changes || [{ key: probe.key, from: probe.from, to: probe.to }];
  }

  function overridesForChanges(changes) {
    return changes.reduce((acc, change) => {
      acc[change.key] = change.to;
      return acc;
    }, {});
  }

  function buildAlternative(probe, count, url) {
    const changes = changesForProbe(probe);
    const parts =
      changes.length === 1
        ? formatAlternativeParts({
            key: probe.key,
            from: probe.from,
            to: probe.to,
            count,
          })
        : formatCombinedAlternativeParts(changes, count);

    return {
      key: probe.key,
      from: probe.from,
      to: probe.to,
      changes,
      count,
      url,
      label: parts.label,
      changeHtml: parts.changeHtml,
      countLabel: parts.countLabel,
    };
  }

  /**
   * Při 0 vozů zjistí, které jedno kritérium stačí uvolnit.
   * @returns {Promise<{ key: string, from: string, to: string, count: number, url: string, label: string, changeHtml: string, countLabel: string }[]>}
   */
  async function findAlternatives() {
    const probes = buildRelaxProbes();
    /** @type {{ key: string, from: string, to: string, count: number, url: string, label: string, changeHtml: string, countLabel: string }[]} */
    const found = [];
    const seenSignatures = new Set();

    const tryProbe = async (probe) => {
      if (found.length >= 3) return;
      const changes = changesForProbe(probe);
      const signature = changes.map((change) => `${change.key}:${change.to}`).join('|');
      if (seenSignatures.has(signature)) return;
      seenSignatures.add(signature);

      const url = buildCollectionUrl(overridesForChanges(changes));
      const count = await fetchFilteredCount(url);
      if (!count || count < 1) return;

      found.push(buildAlternative(probe, count, url));
    };

    for (const probe of probes) {
      if (found.some((alt) => alt.key === probe.key)) continue;
      await tryProbe(probe);
    }

    if (found.length === 0) {
      const combinedProbes = buildCombinedRelaxProbes(probes);
      for (const probe of combinedProbes) {
        await tryProbe(probe);
      }
    }

    return found;
  }

  function renderSummary() {
    if (!summaryEl) return;
    const parts = buildSummaryParts();
    summaryEl.innerHTML = parts.map((text) => `<span class="car-finder__summary-chip">${text}</span>`).join('');
  }

  function syncFinishMatchActions() {
    const actions = root.querySelector('[data-car-finder-finish-match-actions]');
    const emptyPanel = root.querySelector('[data-car-finder-finish-empty]');
    if (!actions || !backBtn || !nav) return;

    const onEmptyFinish = root.classList.contains('is-finish') && emptyPanel && !emptyPanel.hidden;
    const onMatchFinish = root.classList.contains('is-finish') && emptyPanel && emptyPanel.hidden;

    if (onEmptyFinish) {
      actions.hidden = true;
      if (backBtn.parentElement !== nav) nav.insertBefore(backBtn, continueBtn);
      backBtn.hidden = true;
      nav.hidden = true;
      return;
    }

    if (!onMatchFinish) {
      actions.hidden = true;
      if (backBtn.parentElement !== nav) nav.insertBefore(backBtn, continueBtn);
      nav.hidden = false;
      return;
    }

    actions.hidden = false;
    if (backBtn.parentElement !== actions) actions.insertBefore(backBtn, actions.firstChild);
    backBtn.hidden = false;
    nav.hidden = true;
  }

  function clearRedirectFadeTimer() {
    if (!redirectFadeTimer) return;
    window.clearTimeout(redirectFadeTimer);
    redirectFadeTimer = null;
  }

  function trackRedirectTimer(fn, delay) {
    const id = window.setTimeout(fn, delay);
    redirectUiTimers.push(id);
    return id;
  }

  function clearAllRedirectTimers() {
    clearRedirectFadeTimer();
    if (redirectNavTimer) {
      window.clearTimeout(redirectNavTimer);
      redirectNavTimer = null;
    }
    redirectUiTimers.forEach((id) => window.clearTimeout(id));
    redirectUiTimers = [];
  }

  /** Po návratu z kolekce (bfcache) nebo před odchodem z redirectu — čistý start průvodce. */
  function resetWizardToStart() {
    clearAllRedirectTimers();
    noticeText = '';
    setNotice('');

    Object.keys(answers).forEach((key) => {
      answers[key] = null;
    });

    root.classList.remove('is-redirecting', 'is-redirect-leaving', 'is-finish', 'is-finish-reveal', 'is-finish-empty');

    const overlay = root.querySelector('[data-car-finder-redirect-overlay]');
    const loader = root.querySelector('[data-car-finder-loader]');
    const matchPanel = root.querySelector('[data-car-finder-finish-match]');
    const emptyPanel = root.querySelector('[data-car-finder-finish-empty]');
    const finishActions = root.querySelector('.car-finder__finish-actions');
    const phoneForm = root.querySelector('[data-car-finder-phone-form]');
    const phoneHint = root.querySelector('[data-car-finder-empty-text]');
    const phoneSuccess = root.querySelector('[data-car-finder-phone-success]');
    const phoneError = root.querySelector('[data-car-finder-phone-error]');
    const phoneInput = root.querySelector('[data-car-finder-phone-input]');

    if (overlay) overlay.hidden = true;
    if (loader) loader.hidden = true;
    if (matchPanel) matchPanel.hidden = false;
    if (emptyPanel) emptyPanel.hidden = true;
    if (finishActions) finishActions.hidden = true;
    if (phoneForm) phoneForm.hidden = true;
    if (phoneHint) phoneHint.hidden = true;
    if (phoneSuccess) phoneSuccess.hidden = true;
    if (phoneError) {
      phoneError.hidden = true;
      phoneError.textContent = '';
    }
    if (phoneInput) {
      phoneInput.value = '';
      phoneInput.setCustomValidity('');
    }
    if (fallbackLink) fallbackLink.hidden = true;
    if (nav) nav.hidden = false;
    if (continueBtn) continueBtn.hidden = false;
    if (backBtn) {
      backBtn.hidden = true;
      if (nav && backBtn.parentElement !== nav) nav.insertBefore(backBtn, continueBtn);
    }

    root.querySelectorAll('.car-finder__option.is-selected').forEach((el) => {
      el.classList.remove('is-selected');
      el.setAttribute('aria-checked', 'false');
    });

    if (silhouette) {
      clearSwapLayers(silhouette.querySelector('.car-finder-silhouette__stage'));
      resetCarMedia(silhouette.querySelector('.car-finder-silhouette__media'));
    }

    rebuildFlow();
    flowIndex = 0;
    showSlide('purpose');
  }

  function showRedirectOverlay(type) {
    const overlay = root.querySelector('[data-car-finder-redirect-overlay]');
    if (!overlay) return;

    clearRedirectFadeTimer();
    overlay.hidden = false;
    root.classList.remove('is-redirect-leaving');
    root.classList.add('is-redirecting');

    // auto z odpovědí wizardu — ne z aktuálního img (morph animace může být ještě na SUV)
    const redirectCar = root.querySelector('[data-car-finder-redirect-car]');
    const resolvedSrc = silhouetteSrcFor(resolveSilhouetteBody());
    const currentCar = silhouette && silhouette.querySelector('[data-car-finder-car-img]');
    const currentSrc = resolvedSrc || (currentCar && (currentCar.currentSrc || currentCar.getAttribute('src')));
    if (redirectCar && currentSrc) redirectCar.setAttribute('src', currentSrc);

    const copy = config.copy || {};
    const title = root.querySelector('[data-car-finder-redirect-title]');
    const text = root.querySelector('[data-car-finder-redirect-text]');
    if (title) {
      title.textContent =
        type === 'empty'
          ? copy.redirectEmptyTitle || 'Přesné auto teď nemáme.'
          : copy.redirectMatchTitle || 'Auto podle výběru máme.';
    }
    if (text) {
      text.textContent =
        type === 'empty'
          ? copy.redirectEmptyText || 'Nechte nám kontakt a ozveme se s alternativou.'
          : copy.redirectMatchText || 'Přesměrováváme vás do nabídky.';
    }
  }

  function hideRedirectOverlay() {
    const overlay = root.querySelector('[data-car-finder-redirect-overlay]');
    if (!overlay) return;

    clearRedirectFadeTimer();

    if (overlay.hidden) {
      root.classList.remove('is-redirecting', 'is-redirect-leaving');
      return;
    }

    root.classList.add('is-redirect-leaving');
    redirectFadeTimer = window.setTimeout(() => {
      redirectFadeTimer = null;
      overlay.hidden = true;
      root.classList.remove('is-redirecting', 'is-redirect-leaving');
    }, REDIRECT_FADE_MS);
  }

  function transitionDelay() {
    return Math.max(3400, Number(config.redirectDelayMs) || 3400);
  }

  function buildSummaryParts() {
    const parts = [];
    const order = ['purpose', 'body', 'fuel', 'charger', 'transmission', 'drive', 'tow', 'seats', 'mileage', 'term'];
    order.forEach((key) => {
      let val = answers[key];
      if (key === 'fuel') val = effectiveFuel();
      if (key === 'transmission' && isElectricPath()) val = 'automatic';
      if (key === 'charger' && answers.fuel === 'electric' && answers.charger === 'no') {
        parts.push('Bez nabíječky → hybrid');
        return;
      }
      if (!val || val === 'any') return;
      if (key === 'charger' && val === 'yes') {
        parts.push(LABEL.charger.yes);
        return;
      }
      parts.push(LABEL[key]?.[val] || val);
    });
    return parts;
  }

  function mileageNumber() {
    const raw = config.mileageOptions?.[answers.mileage] || '';
    const digits = String(raw).replace(/[^\d]/g, '');
    return digits || '';
  }

  function buildFindCarNote() {
    const sentences = [];
    sentences.push(
      'Dobrý den, na webu jsem prošel osobní výběr auta a v aktuální nabídce teď nemáte přesnou kombinaci — proto vás prosím o nezávazné probrání po telefonu.',
    );

    const body = LABEL.body[answers.body];
    const fuel = LABEL.fuel[effectiveFuel()];
    const bits = [];
    if (body) bits.push(body.toLowerCase());
    if (fuel && answers.fuel !== 'any') bits.push(fuel.toLowerCase());
    if (answers.transmission === 'automatic' || isElectricPath()) bits.push('automatickou převodovku');
    else if (answers.transmission === 'manual') bits.push('manuální převodovku');
    if (answers.drive === 'awd') bits.push('pohon 4×4');
    if (answers.tow === 'yes') bits.push('tažné zařízení');
    if (answers.seats === 'seven') bits.push('7 míst');
    if (bits.length) {
      sentences.push(`Hledám ideálně: ${bits.join(', ')}.`);
    }

    const purpose = LABEL.purpose[answers.purpose];
    if (purpose) {
      sentences.push(`Účel použití: ${purpose.toLowerCase()}.`);
    }

    if (answers.fuel === 'electric' && answers.charger === 'yes') {
      sentences.push('Mám přístup k nabíječce.');
    } else if (answers.fuel === 'electric' && answers.charger === 'no') {
      sentences.push('Nemám přístup k nabíječce, proto dává smysl spíš hybrid.');
    }

    const mileageLabel = LABEL.mileage[answers.mileage];
    const termLabel = LABEL.term[answers.term];
    const contract = [];
    if (mileageLabel) contract.push(`roční nájezd ${mileageLabel.toLowerCase()}`);
    if (termLabel && answers.term !== 'any') contract.push(`smlouvu na ${termLabel}`);
    if (contract.length) {
      sentences.push(`Preferuji ${contract.join(' a ')}.`);
    }

    sentences.push('Budu rád za nezávaznou nabídku nebo podobné alternativy. Děkuji.');
    return sentences.join(' ');
  }

  function digitsOnly(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function sanitizePhoneNine(value) {
    return digitsOnly(value).slice(0, 9);
  }

  function formatPhoneNine(value) {
    return sanitizePhoneNine(value).replace(/(\d{3})(?=\d)/g, '$1 ');
  }

  function buildEmptyLeadPayload(phoneE164) {
    return {
      source: 'car-finder',
      'Phone number': phoneE164,
      phone: phoneE164,
      annualMileage: mileageNumber(),
      note: buildFindCarNote(),
      answers: { ...answers, effectiveFuel: effectiveFuel() },
      summary: buildSummaryParts(),
      createdAt: new Date().toISOString(),
      pageUrl: window.location.href,
    };
  }

  function bindEmptyPhoneForm() {
    const form = root.querySelector('[data-car-finder-phone-form]');
    const input = root.querySelector('[data-car-finder-phone-input]');
    const submitBtn = root.querySelector('[data-car-finder-phone-submit]');
    const errorEl = root.querySelector('[data-car-finder-phone-error]');
    const successEl = root.querySelector('[data-car-finder-phone-success]');
    const hintEl = root.querySelector('[data-car-finder-empty-text]');
    if (!form || !input || form.dataset.bound === '1') return;
    form.dataset.bound = '1';

    const invalidMsg = 'Zadejte přesně 9 číslic (předvolbu +420 nepište).';

    const showError = (msg) => {
      if (!errorEl) return;
      errorEl.textContent = msg || '';
      errorEl.hidden = !msg;
    };

    input.addEventListener('input', () => {
      const next = formatPhoneNine(input.value);
      if (input.value !== next) input.value = next;
      input.setCustomValidity('');
      showError('');
    });

    input.addEventListener('paste', (event) => {
      event.preventDefault();
      const paste = (event.clipboardData || window.clipboardData).getData('text');
      const start = input.selectionStart ?? 0;
      const end = input.selectionEnd ?? 0;
      const before = input.value.slice(0, start);
      const after = input.value.slice(end);
      input.value = formatPhoneNine(before + digitsOnly(paste) + after);
      input.setCustomValidity('');
      showError('');
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const digits = sanitizePhoneNine(input.value);
      if (digits.length !== 9) {
        input.setCustomValidity(invalidMsg);
        input.reportValidity();
        showError(invalidMsg);
        return;
      }
      input.setCustomValidity('');
      input.value = formatPhoneNine(digits);
      showError('');

      const webhookUrl =
        (typeof config.emptyWebhookUrl === 'string' && config.emptyWebhookUrl.trim()) ||
        new URLSearchParams(window.location.search).get('empty_webhook') ||
        '';

      if (!webhookUrl) {
        showError('Odeslání teď není dostupné. Zkuste to prosím později nebo nám zavolejte.');
        return;
      }

      const originalLabel = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) {
        submitBtn.textContent = 'Odesílám...';
        submitBtn.disabled = true;
      }

      const phoneE164 = `+420${digits}`;
      const payload = buildEmptyLeadPayload(phoneE164);

      try {
        const response = await fetch(webhookUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        if (!response.ok) {
          throw new Error(`Webhook ${response.status}`);
        }

        form.hidden = true;
        if (hintEl) hintEl.hidden = true;
        if (successEl) successEl.hidden = false;
        const browseCta = root.querySelector('[data-car-finder-browse-cta]');
        if (browseCta) browseCta.hidden = false;
        pushDataLayer('car_finder_empty_lead', {
          phone: phoneE164,
          answers: { ...answers, effectiveFuel: effectiveFuel() },
        });
      } catch {
        showError('Nepodařilo se odeslat. Zkuste to znovu.');
        if (submitBtn) {
          submitBtn.textContent = originalLabel || 'Zkusit znovu';
          submitBtn.disabled = false;
        }
      }
    });
  }

  async function fetchFilteredCount(collectionUrl) {
    try {
      // Nesmíme pouštět filtry přes URLSearchParams — rozbije to
      // Shopify klíče typu "roční+nájezd" (+ = mezera) a count pak lže.
      // Nesmíme posílat Accept: application/json — Shopify pak vrátí nativní
      // /collections/... JSON (products_count celé kolekce) a view= ignoruje.
      const withoutHash = String(collectionUrl).split('#')[0];
      const sep = withoutHash.includes('?') ? '&' : '?';
      const countUrl = `${withoutHash}${sep}view=car-finder-count`;
      const res = await fetch(countUrl, {
        headers: { Accept: 'text/html,application/xhtml+xml' },
        credentials: 'same-origin',
      });
      if (!res.ok) return null;
      const text = await res.text();
      const data = JSON.parse(text);

      // Ochrana: nativní Shopify collection JSON nemá hasProducts
      if (
        data &&
        data.collection &&
        typeof data.collection.products_count === 'number' &&
        data.hasProducts === undefined
      ) {
        return null;
      }

      if (typeof data.count === 'number') return data.count;
      if (typeof data.hasProducts === 'boolean') return data.hasProducts ? 1 : 0;
      return null;
    } catch {
      return null;
    }
  }

  function showEmptyFinish(collectionUrl, options) {
    const alternatives = (options && options.alternatives) || [];
    const matchPanel = root.querySelector('[data-car-finder-finish-match]');
    const emptyPanel = root.querySelector('[data-car-finder-finish-empty]');
    const emptySummary = root.querySelector('[data-car-finder-empty-summary]');
    const alternativesWrap = root.querySelector('[data-car-finder-alternatives]');
    const alternativesList = root.querySelector('[data-car-finder-alternatives-list]');
    const browseCta = root.querySelector('[data-car-finder-browse-cta]');
    const loader = root.querySelector('[data-car-finder-loader]');
    const phoneForm = root.querySelector('[data-car-finder-phone-form]');
    const finishActions = root.querySelector('.car-finder__finish-actions');
    const phoneHint = root.querySelector('[data-car-finder-empty-text]');
    const phoneSuccess = root.querySelector('[data-car-finder-phone-success]');
    const phoneError = root.querySelector('[data-car-finder-phone-error]');
    const phoneInput = root.querySelector('[data-car-finder-phone-input]');
    const phoneSubmit = root.querySelector('[data-car-finder-phone-submit]');

    if (matchPanel) matchPanel.hidden = true;
    if (emptyPanel) emptyPanel.hidden = false;
    if (loader) loader.hidden = true;
    root.classList.add('is-finish-empty');
    showRedirectOverlay('empty');
    if (emptySummary) {
      const parts = buildSummaryParts();
      emptySummary.innerHTML = parts.length
        ? parts.map((text) => `<span class="car-finder__summary-chip">${text}</span>`).join('')
        : '';
      emptySummary.hidden = !parts.length;
    }

    if (alternativesList) {
      alternativesList.innerHTML = '';
      alternatives.forEach((alt) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'car-finder__alternative';
        btn.setAttribute('data-car-finder-alternative', '');
        btn.setAttribute('data-key', alt.key);
        btn.setAttribute('data-from', alt.from);
        btn.setAttribute('data-to', alt.to);
        btn.setAttribute('data-count', String(alt.count));
        btn.setAttribute('aria-label', alt.label);
        btn.innerHTML = `
          <p class="car-finder__alternative-change">${alt.changeHtml}</p>
          <p class="car-finder__alternative-count">${alt.countLabel}</p>
          <p class="car-finder__alternative-cta">Zobrazit nabídku</p>
        `;
        btn.addEventListener('click', () => {
          pushDataLayer('car_finder_alternative_accepted', {
            key: alt.key,
            from: alt.from,
            to: alt.to,
            changes: alt.changes || [{ key: alt.key, from: alt.from, to: alt.to }],
            count: alt.count,
            url: alt.url,
            answers: { ...answers, effectiveFuel: effectiveFuel() },
          });
          (alt.changes || [{ key: alt.key, to: alt.to }]).forEach((change) => {
            answers[change.key] = change.to;
          });
          applyConstraints(alt.key);
          rebuildFlow();
          window.location.href = buildCollectionUrl();
        });
        alternativesList.appendChild(btn);
      });
    }
    if (alternativesWrap) {
      alternativesWrap.hidden = alternatives.length === 0;
    }

    if (browseCta) {
      browseCta.setAttribute(
        'href',
        appendCarFinderUtm(config.fallbackUrl || `/collections/${config.collectionHandle || 'operativni-leasing'}`),
      );
      browseCta.hidden = true;
    }
    if (finishActions) finishActions.hidden = true;
    if (phoneForm) phoneForm.hidden = true;
    if (phoneHint) phoneHint.hidden = true;
    if (phoneSuccess) phoneSuccess.hidden = true;
    if (phoneError) {
      phoneError.hidden = true;
      phoneError.textContent = '';
    }
    if (phoneInput) {
      phoneInput.value = '';
      phoneInput.setCustomValidity('');
    }
    if (phoneSubmit) {
      phoneSubmit.disabled = false;
      phoneSubmit.textContent = config.copy?.emptyCta || 'Odeslat telefon';
    }
    bindEmptyPhoneForm();
    if (continueBtn) continueBtn.hidden = true;
    if (backBtn) backBtn.hidden = true;
    if (nav) nav.hidden = true;

    pushDataLayer('car_finder_empty', {
      url: collectionUrl,
      answers: { ...answers, effectiveFuel: effectiveFuel() },
      blockingCriteria: alternatives.map((alt) => alt.key),
      alternatives: alternatives.map((alt) => ({
        key: alt.key,
        from: alt.from,
        to: alt.to,
        changes: alt.changes || [{ key: alt.key, from: alt.from, to: alt.to }],
        count: alt.count,
      })),
      hasAlternatives: alternatives.length > 0,
    });
    syncFinishMatchActions();

    root.classList.remove('is-finish-reveal');

    trackRedirectTimer(() => {
      hideRedirectOverlay();

      // obsah naskočí až po dofadeování mezistavu, ať se překryvy nebijí
      trackRedirectTimer(() => {
        if (finishActions) finishActions.hidden = false;
        if (phoneForm) phoneForm.hidden = false;
        if (phoneHint) phoneHint.hidden = false;
        syncFinishMatchActions();
        // restart animace, aby se reveal spustil i při opakovaném dokončení
        void root.offsetWidth;
        root.classList.add('is-finish-reveal');
      }, REDIRECT_FADE_MS);
    }, transitionDelay());
  }

  function showMatchFinish(collectionUrl, options) {
    const preview = options && options.preview;
    const matchPanel = root.querySelector('[data-car-finder-finish-match]');
    const emptyPanel = root.querySelector('[data-car-finder-finish-empty]');
    const loader = root.querySelector('[data-car-finder-loader]');
    if (matchPanel) matchPanel.hidden = false;
    if (emptyPanel) emptyPanel.hidden = true;
    if (loader) loader.hidden = true;
    root.classList.remove('is-finish-empty');
    const alternativesWrap = root.querySelector('[data-car-finder-alternatives]');
    if (alternativesWrap) alternativesWrap.hidden = true;
    showRedirectOverlay('match');

    const fallback = config.fallbackUrl || `/collections/${config.collectionHandle || 'operativni-leasing'}`;

    if (fallbackLink) {
      fallbackLink.href = appendCarFinderUtm(fallback);
      fallbackLink.hidden = preview ? false : true;
    }

    if (preview) {
      syncFinishMatchActions();
      return;
    }

    const delay = transitionDelay();
    trackRedirectTimer(
      () => {
        root.classList.add('is-redirect-leaving');
      },
      Math.max(0, delay - REDIRECT_FADE_MS),
    );

    redirectNavTimer = window.setTimeout(() => {
      redirectNavTimer = null;
      window.location.href = collectionUrl;
    }, delay);

    trackRedirectTimer(() => {
      if (fallbackLink) fallbackLink.hidden = false;
      syncFinishMatchActions();
    }, delay + 2500);
  }

  async function finish() {
    renderSummary();
    updateSilhouette();
    const url = buildCollectionUrl();

    pushDataLayer('car_finder_finish', { url, answers: { ...answers, effectiveFuel: effectiveFuel() } });

    const matchPanel = root.querySelector('[data-car-finder-finish-match]');
    const emptyPanel = root.querySelector('[data-car-finder-finish-empty]');
    if (matchPanel) matchPanel.hidden = false;
    if (emptyPanel) emptyPanel.hidden = true;

    const loader = root.querySelector('[data-car-finder-loader]');
    if (loader) loader.hidden = false;
    hideRedirectOverlay();
    if (fallbackLink) fallbackLink.hidden = true;
    syncFinishMatchActions();

    const count = await fetchFilteredCount(url);

    if (count === 0) {
      const alternatives = await findAlternatives();
      showEmptyFinish(url, { alternatives });
      return;
    }

    if (count === null) {
      const verified = await verifyCollectionHasProducts(url);
      if (verified === true) {
        showMatchFinish(url);
        return;
      }
      const alternatives = await findAlternatives();
      showEmptyFinish(url, { alternatives });
      return;
    }

    showMatchFinish(url);
  }

  async function verifyCollectionHasProducts(collectionUrl) {
    try {
      const withoutHash = String(collectionUrl).split('#')[0];
      const sep = withoutHash.includes('?') ? '&' : '?';
      const res = await fetch(`${withoutHash}${sep}sections=main-collection-product-grid`, {
        headers: { Accept: 'text/html' },
        credentials: 'same-origin',
      });
      if (!res.ok) return null;
      const data = await res.json();
      const html = data && (data['main-collection-product-grid'] || Object.values(data)[0] || '');
      if (!html || typeof html !== 'string') return null;
      if (/collection--empty|Žádné produkty|zadne produkty|no products|empty-state/i.test(html)) return false;
      if (/card-product|product-card|data-product-id/i.test(html)) return true;
      if (/ProductGridContainer/i.test(html) && !/card-product|product-card/i.test(html)) return false;
      return null;
    } catch {
      return null;
    }
  }

  function readPreviewMode() {
    try {
      const mode = new URLSearchParams(window.location.search).get('preview');
      if (!mode || !mode.startsWith('finish')) return null;
      return mode;
    } catch {
      return null;
    }
  }

  const EMPTY_PREVIEW_COMBOS = [
    {
      purpose: 'long_trips',
      body: 'hatch',
      fuel: 'electric',
      charger: 'yes',
      transmission: 'automatic',
      drive: 'awd',
      tow: 'yes',
      seats: 'five',
      mileage: 'low',
      term: '24',
    },
    {
      purpose: 'adventure',
      body: 'hatch',
      fuel: 'electric',
      charger: 'yes',
      transmission: 'automatic',
      drive: 'awd',
      tow: 'yes',
      seats: 'five',
      mileage: 'low',
      term: '36',
    },
    {
      purpose: 'city',
      body: 'sedan',
      fuel: 'electric',
      charger: 'yes',
      transmission: 'automatic',
      drive: 'awd',
      tow: 'yes',
      seats: 'five',
      mileage: 'low',
      term: '24',
    },
    {
      purpose: 'family',
      body: 'hatch',
      fuel: 'combustion',
      charger: null,
      transmission: 'manual',
      drive: 'awd',
      tow: 'yes',
      seats: 'five',
      mileage: 'low',
      term: '24',
    },
  ];

  function applyPreviewAnswers(preset) {
    Object.assign(
      answers,
      preset || {
        purpose: 'family',
        body: 'kombi',
        fuel: 'hybrid',
        transmission: 'automatic',
        drive: 'fwd',
        tow: 'no',
        seats: 'five',
        mileage: 'mid',
        term: '36',
      },
    );
    applyConstraints();
    rebuildFlow();
  }

  function bootPreview(mode) {
    const emptyPreset =
      mode === 'finish-empty' ? EMPTY_PREVIEW_COMBOS[Math.floor(Math.random() * EMPTY_PREVIEW_COMBOS.length)] : null;
    applyPreviewAnswers(emptyPreset);
    flowIndex = Math.max(0, flow.indexOf('finish'));
    showSlide('finish');
    renderSummary();
    updateSilhouette();

    const collectionUrl = buildCollectionUrl();
    const loader = root.querySelector('[data-car-finder-loader]');
    const matchPanel = root.querySelector('[data-car-finder-finish-match]');
    const emptyPanel = root.querySelector('[data-car-finder-finish-empty]');

    if (mode === 'finish-empty') {
      void finish();
      return;
    }

    if (matchPanel) matchPanel.hidden = false;
    if (emptyPanel) emptyPanel.hidden = true;

    if (mode === 'finish-match') {
      showMatchFinish(collectionUrl, { preview: true });
      return;
    }

    if (loader) loader.hidden = false;
    if (fallbackLink) fallbackLink.hidden = true;
    syncFinishMatchActions();
  }

  root.querySelectorAll('[data-answer]').forEach((btn) => {
    btn.addEventListener('click', () => {
      if (btn.disabled || btn.hidden) return;
      const key = btn.getAttribute('data-answer');
      const value = btn.getAttribute('data-value');
      if (!key || !value) return;

      answers[key] = value;

      const group = btn.closest('.car-finder__options');
      if (group) {
        group.querySelectorAll('.car-finder__option').forEach((el) => {
          el.classList.remove('is-selected');
          el.setAttribute('aria-checked', 'false');
        });
      }
      btn.classList.add('is-selected');
      btn.setAttribute('aria-checked', 'true');

      if (key === 'fuel') {
        answers.charger = null;
      }

      if (key === 'purpose') {
        answers.body = PURPOSE_BODY_HINT[value] || null;
        warmCarBodies();
      }

      if (key === 'body' || key === 'tow') {
        warmCarBodies();
      }

      if (key === 'body') {
        if (!bodyAllowsSeven(value) && answers.seats === 'seven') {
          answers.seats = 'five';
        }
        if (!bodyAllowsSeven(value)) {
          answers.seats = answers.seats === 'seven' ? 'five' : answers.seats || 'five';
        }
      }

      applyConstraints(key);
      rebuildFlow();
      updateOptionVisibility();
      updateSilhouette();
      syncContinueButton();
    });
  });

  if (continueBtn) {
    continueBtn.addEventListener('click', () => {
      if (continueBtn.disabled || continueBtn.hidden) return;
      const key = currentSlideKey();
      if (!key || key === 'finish' || !answers[key]) return;
      advanceToNext();
    });
  }

  if (backBtn) {
    backBtn.addEventListener('click', () => {
      if (flowIndex <= 0) return;
      noticeText = '';
      goTo(flowIndex - 1);
    });
  }

  optionsScrollEls.forEach((el) => {
    el.addEventListener('scroll', requestOptionsScrollFadeSync, { passive: true });
  });

  window.addEventListener('resize', requestOptionsScrollFadeSync);

  window.addEventListener('pagehide', () => {
    if (root.classList.contains('is-redirecting')) {
      resetWizardToStart();
    }
  });

  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    if (root.classList.contains('is-redirecting') || root.classList.contains('is-redirect-leaving')) {
      resetWizardToStart();
    }
  });

  root.hidden = false;
  root.classList.add('is-open');
  root.setAttribute('aria-hidden', 'false');
  pushDataLayer('car_finder_start', { path: window.location.pathname });
  if (silhouette) {
    clearSwapLayers(silhouette.querySelector('.car-finder-silhouette__stage'));
    resetCarMedia(silhouette.querySelector('.car-finder-silhouette__media'));
  }
  rebuildFlow();
  const scheduleWarm =
    typeof window.requestIdleCallback === 'function'
      ? (fn) => window.requestIdleCallback(fn, { timeout: 1200 })
      : (fn) => window.setTimeout(fn, 200);
  scheduleWarm(warmCarBodies);
  const previewMode = readPreviewMode();
  if (previewMode) {
    bootPreview(previewMode);
  } else {
    showSlide('purpose');
  }
  requestOptionsScrollFadeSync();
})();
